var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0938 4.46826V0.515625C19.6588 1.96675 22.7579 6.20623 22.7621 10.9983C22.7538 15.7862 19.6546 20.0172 15.0938 21.4684V17.5326C17.5522 16.2797 19.0976 13.7572 19.0976 10.9983C19.0934 8.2395 17.548 5.72112 15.0938 4.46826ZM0.761719 10.9974C0.765907 6.20952 3.86928 1.97425 8.4301 0.527344V4.45888C5.97169 5.70753 4.42629 8.23434 4.42629 10.9932C4.43048 13.752 5.97588 16.2704 8.4301 17.5232V21.4759C3.86509 20.0247 0.761719 15.7895 0.761719 10.9974Z",
    fill: "#3D92EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7591 0C10.9508 0.00421839 10.1467 0.101241 9.35938 0.282632V4.07918C10.13 3.80499 10.9425 3.66578 11.7591 3.66156C12.5758 3.66578 13.3883 3.80499 14.1589 4.07497V0.274195C13.3716 0.097023 12.5674 0.00421839 11.7591 0ZM11.7591 7.16797C10.8838 7.16797 10.0378 7.47169 9.35938 8.02008V13.9807C10.0378 14.5291 10.888 14.8328 11.7591 14.8328C12.6345 14.8328 13.4804 14.5291 14.1589 13.9807V8.02008C13.4804 7.47169 12.6345 7.16797 11.7591 7.16797ZM11.767 18.3395C12.5836 18.3353 13.3961 18.1961 14.1667 17.9219V21.7184C13.3794 21.8998 12.5753 21.9968 11.767 22.0011C10.9587 21.9968 10.1545 21.9083 9.36719 21.7269V17.9261C10.1378 18.1961 10.9503 18.3353 11.767 18.3395Z",
    fill: "#81BFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35938 9.99983C10.1509 9.89859 10.955 9.84797 11.7633 9.84375C12.5716 9.84797 13.3757 9.89859 14.1631 9.99561V21.7354C13.3757 21.8366 12.5716 21.8873 11.7633 21.8915C10.955 21.8873 10.1467 21.8366 9.35938 21.7396V9.99983Z",
    fill: "#81BFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIo);
export default __webpack_public_path__ + "static/media/io.a08a53efd30e02919507686496b8e269.svg";
export { ForwardRef as ReactComponent };